import sc from 'styled-components';
import React, { Component } from 'react';
import _ from 'lodash';
import {
  WHITE, GREEN_DARK, GRAY, BLACK, GRAY_LIGHT, BODY_FONT_FAMILY,
  BLUE_LIGHT, ACCENT_ORANGE,
} from './styleConstants';
import { MAX_WEIGHT } from '../appConstants';

const WeightList = sc.div`
display: flex;
flex-direction: row;
justify-content: flex-start;
`;

const WeightPip = sc.div`
font: ${BODY_FONT_FAMILY};
padding: 3px;
width: 20px;
text-align: center;
font-weight: normal;
font-size: 0.9rem;
line-height: 110%;
user-select: none; /* supported by Chrome and Opera */
-webkit-user-select: none; /* Safari */
-khtml-user-select: none; /* Konqueror HTML */
-moz-user-select: none; /* Firefox */
-ms-user-select: none; /* Internet Explorer/Edge */
:hover {
  color: ${ACCENT_ORANGE}!important;
}
`;

const STYLE_EQ = { color: WHITE, backgroundColor: GREEN_DARK, borderRadius: '0 3px 3px 0' };
const STYLE_PASSED = { color: BLUE_LIGHT, backgroundColor: GREEN_DARK };
const STYLE_GT = { color: BLUE_LIGHT };

const STYLE_EQ_EMPTY = { ...STYLE_EQ, backgroundColor: GRAY };
const STYLE_PASSED_EMPTY = { ...STYLE_PASSED, color: GRAY_LIGHT, backgroundColor: GRAY };
const STYLE_GT_EMPTY = { ...STYLE_GT, color: GRAY_LIGHT };

export default class WeightWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weight: _.get(props, 'weight', 0),
    };
  }

  static getDerivedStateFromProps(props, state) {
    return { ...state, weight: _.get(props, 'weight', 0) };
  }

  setWeight(weight) {
    if (!_.isNumber(weight)) {
      return;
    }
    // eslint-disable-next-line no-param-reassign
    weight = _.clamp(weight, 0, MAX_WEIGHT);
    this.setState({ weight });
    if (this.props.onChange) {
      this.props.onChange(weight);
    }
  }

  offsetWeight(n) {
    const weight = _.get(this, 'state.weight', 0);
    const newWeight = _.clamp(weight + n, 0, MAX_WEIGHT);
    if (weight !== newWeight) {
      this.setWeight(newWeight);
    }
  }

  get keyPressed() {
    return (event) => {
      const key = _.get(event, 'key', '');
      if (!key) {
        return;
      }

      switch (key) {
        case '.':
          this.offsetWeight(1);
          break;

        case ',':
          this.offsetWeight(-1);
          break;

        case '`':
          this.setWeight(0);
          break;

        default:
          if (/[\d/]/.test(key)) {
            this.setWeight(parseInt(key, 10));
          }
      }
    };
  }

  render() {
    const { weight } = this.state;
    const { empty } = this.props;
    return (
      <WeightList tabIndex={this.props.tabIndex} data-type="weight-list" onKeyPress={this.keyPressed}>
        {_.range(0, MAX_WEIGHT + 1).map((weightNum) => {
          let style = STYLE_GT;
          if (empty) {
            if (weightNum < weight) {
              style = STYLE_PASSED_EMPTY;
            } else if (weightNum === weight) {
              style = STYLE_EQ_EMPTY;
            } else {
              style = STYLE_GT_EMPTY;
            }
          } else if (weightNum < weight) {
            style = STYLE_PASSED;
          } else if (weightNum === weight) {
            style = STYLE_EQ;
          }
          return (
            <WeightPip
              key={weightNum}
              onClick={() => this.setWeight(weightNum)}
              style={style}
              data-type="weight-pip"
            >{weightNum}
            </WeightPip>
          );
        })}
      </WeightList>
    );
  }
}
